import React from 'react';
import TiMediaPause from 'react-icons/lib/ti/media-pause';
import IoLoadC from 'react-icons/lib/io/load-c';
import FaCheck from 'react-icons/lib/fa/check';

const IconOverlays = ({ showPauseOverlay, showLoadingOverlay, showCheckmarkOverlay }) => (
  <div className="iconOverlays">
    {showPauseOverlay && (
      <div className='pauseOverlay'>
        <TiMediaPause size="50" />
      </div>
    )}
    {showLoadingOverlay && (
      <div className='loadingOverlay'>
        <IoLoadC size="400" />
      </div>
    )}
    {showCheckmarkOverlay && (
      <div className='checkmarkOverlay'>
        <FaCheck size="50" />
      </div>
    )}
  </div>
);

export default IconOverlays;
